var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination-container", class: { hidden: _vm.hidden } },
    [
      _c(
        "el-pagination",
        _vm._b(
          {
            attrs: {
              background: _vm.background,
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              layout: _vm.layout,
              "page-sizes": _vm.pageSizes,
              total: _vm.total,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "update:pageSize": function ($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function ($event) {
                _vm.pageSize = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          },
          "el-pagination",
          _vm.$attrs,
          false
        ),
        [
          _c("div", { staticClass: "slot-block" }, [
            _c(
              "div",
              { staticClass: "page-jumper" },
              [
                _c("span", [_vm._v("Go to")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: { maxlength: "4" },
                  on: { input: _vm.jumpPageCheck },
                  model: {
                    value: _vm.currPage,
                    callback: function ($$v) {
                      _vm.currPage = $$v
                    },
                    expression: "currPage",
                  },
                }),
                _vm._v(" "),
                _c("el-button", {
                  staticClass: "jump-btn",
                  attrs: { type: "primary", icon: "el-icon-back" },
                  on: { click: _vm.jumpPage },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }